$(function() {
    Proj.init();
});